function cov_1vjeyxfefq() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/components/views/Gateway.tsx";
    var hash = "12da65931339568f9386b78fd1ab99a0197088bd";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/components/views/Gateway.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 7,
                    column: 26
                },
                end: {
                    line: 25,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 8,
                    column: 1
                },
                end: {
                    line: 24,
                    column: 7
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 7,
                        column: 26
                    },
                    end: {
                        line: 7,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 1
                    },
                    end: {
                        line: 24,
                        column: 7
                    }
                },
                line: 8
            }
        },
        branchMap: {},
        s: {
            "0": 0,
            "1": 0
        },
        f: {
            "0": 0
        },
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "12da65931339568f9386b78fd1ab99a0197088bd"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_1vjeyxfefq = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_1vjeyxfefq();
import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTES } from 'vio-constants';
import Login from './Login';
cov_1vjeyxfefq().s[0]++;
const Gateway = () => {
    cov_1vjeyxfefq().f[0]++;
    cov_1vjeyxfefq().s[1]++;
    return React.createElement("div", {
        id: "gateway-container"
    }, React.createElement(Routes, null, React.createElement(Route, {
        path: ROUTES.AUTH,
        element: React.createElement(Login, null)
    }), React.createElement(Route, {
        path: "*",
        element: React.createElement(Navigate, {
            replace: true,
            to: ROUTES.AUTH
        })
    })));
};
export default Gateway;
